import { createSelector } from "reselect";
import { isEmpty } from "lodash";

const getListadoCobros = state => state.cobros.listadoCobros;
const getIdActividad = state => state.cobros.actividadSeleccionada;

const getCobrosActividad = createSelector(
  [getListadoCobros, getIdActividad],
  (listado, actividad) =>
    isEmpty(listado) || isEmpty(actividad)
      ? []
      : listado.filter(item => item.concepto === actividad.actividad)
);

export { getCobrosActividad };



// WEBPACK FOOTER //
// ./src/ducks/cobros/selectors.js